export default "__VITE_ASSET__dQBWFFcH__"